__turbopack_context__.v({
  "confirm": "StarRatingSelector-module__SDxdAW__confirm",
  "confirmButton": "StarRatingSelector-module__SDxdAW__confirmButton",
  "disabled": "StarRatingSelector-module__SDxdAW__disabled",
  "question": "StarRatingSelector-module__SDxdAW__question",
  "star": "StarRatingSelector-module__SDxdAW__star",
});
